export default __webpack_public_path__ + "static/media/to-do-list.053c556a.png";